import { logger as LOG } from '@garnish/logger';

// ────────────────────────────────────────────────────────────────────────────────
// LOG.enable('URQL');
export const logger = LOG.extend('URQL');
// ────────────────────────────────────────────────────────────────────────────────
